 <!-- <p-sidebar [(visible)]="visible" (onHide)="onHide()" position="bottom" styleClass="h-30rem" transitionOptions="500ms cubic-bezier(0, 0, 0.2, 1)">
  <div class="flex flex-column align-items-center">
    <div class="flex text-center">
      <h3>Puedes encontrar el IMEI mediante el marcador del teléfono</h3>
    </div>
    <div class="flex">
      <ul class="list-decimal font-bold">
        <li><p class="font-normal">En la pantalla de inicio, toca el icono de marcador del teléfono.</p> </li>
        <li><p class="font-normal">Busca y toca el icono del teclado de marcación</p></li>
        <li><p class="font-normal">Escribe el siguiente código <span class="bg-blue-100 font-bold px-1">*#06#</span> y veras una pantalla con tu IMEI</p></li>
      </ul>
    </div>
    <div class="flex justify-content-center align-items-center">
      <p-button type="submit" (onClick)="onIntroduceIMEI()">
        <label class="text-xl font-bold cursor-pointer">Ok, ya tengo mi IMEI</label>
      </p-button>
    </div>
  </div>
</p-sidebar>  -->


<p-dialog [(visible)]="visible" (onHide)="onHide()" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>¿Dónde encontrar mi IMEI?</h2>
        </div>
        <div class="dialog__text smallPad">
          <h3>Método general</h3>
          <ol>
            <li>Abre la aplicación de llamadas en tu teléfono.</li>
            <li>Marca el código: *#06#.</li>
            <li>El IMEI aparecerá automáticamente en la pantalla.</li>
          </ol>

          <h3>Método alternativo en Android</h3>
          <ol>
            <li>Ve a Ajustes o Configuración.</li>
            <li>Selecciona Acerca del teléfono o Información del dispositivo.</li>
            <li>Busca el apartado llamado Estado o IMEI.</li>
          </ol>

          <h3>Método alternativo en iOS (iPhone)</h3>
          <ol>
            <li>Ve a Configuración.</li>
            <li>Selecciona General y luego Información.</li>
            <li>Busca el IMEI en la lista de detalles.</li>
          </ol>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Ok, ya tengo mi IMEI" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onIntroduceIMEI()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

